export default __webpack_public_path__ + "static/media/terms-check-prime.43e571f2.svg";